import $ from 'jquery';

let popups = {};

function init() {
    $('.popups .popup').each(function () {
        popups[this.id] = $(this);
    });

    events();
}

const transitionend = 'transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd';

function open(name) {
    if (popups[name]) {
        let popup = popups[name];

        if (popup.is('.open')) {
            return;
        }

        $(document).trigger('balloon:popup:opening', [name, popup]);
        popup.removeClass('opening open closing closed').addClass('opening open');
        popup.find('.popup-overlay, .popup-contents').addBack().one(transitionend, function (event) {
            popup.removeClass('opening');
        });
        $(document).trigger('balloon:popup:opened', [name, popup]);
    }
}

function close(name) {
    if (popups[name]) {
        let popup = popups[name];

        if (popup.is('.closed')) {
            return;
        }

        $(document).trigger('balloon:popup:closing', [name, popup]);
        popup.removeClass('opening open closing closed').addClass('closing closed');
        popup.find('.popup-overlay, .popup-contents').addBack().one(transitionend, function (event) {
            popup.removeClass('closing');
        });
        $(document).trigger('balloon:popup:closed', [name, popup]);
    }
}

function events() {
    let $triggers = $('a[data-popup], button[data-popup]');

    $triggers.on('click', function (event) {
        let $button = $(this);
        event.preventDefault();

        let action = $button.data('popup-action') || 'open';

        if (action === 'open') {
            open($button.data('popup'));
        }
        if (action === 'close') {
            close($button.data('popup'));
        }
    });

    $('.popups .popup .popup-container').on('click', function (event) {
        if ($(event.target).is(this)) {
            close($(this).closest('.popup').attr('id'));
        }
    });
}

export default {init: init, open: open, close: close};
